import { render, staticRenderFns } from "./CatalogRecordItem.vue.js?vue&type=template&id=71ee343a&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CatalogRecordItem.vue?vue&type=template&id=71ee343a&scoped=true"
import script from "./CatalogRecordItem.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CatalogRecordItem.vue?vue&type=script&lang=js"
export * from "./CatalogRecordItem.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CatalogRecordItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ee343a",
  null
  
)

export default component.exports